import { render, staticRenderFns } from "./AttachedDocuments.vue?vue&type=template&id=490e186a&scoped=true&"
import script from "./AttachedDocuments.vue?vue&type=script&lang=js&"
export * from "./AttachedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AttachedDocuments.vue?vue&type=style&index=0&id=490e186a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e186a",
  null
  
)

export default component.exports